import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	sidebarNavigation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sideBarPanelSplitterLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sideBarPanelSplitterTooltipContent: {
		id: string;
		description: string;
		defaultMessage: string;
	};
	globalInviteButtonLabel: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	sidebarNavigation: {
		id: 'page-container-v2.common.sidebar.sidebar-navigation',
		defaultMessage: 'Sidebar navigation',
		description:
			'The (>)/(<) button label for expand and collapse sidebar in the sidebar navigation, hover to see the text.',
	},
	sideBarPanelSplitterLabel: {
		id: 'page-container-v2.common.sidebar.side-bar-panel-splitter-label',
		defaultMessage: 'Resize side navigation panel',
		description: 'Button label for resizing the side navigation panel',
	},
	sideBarPanelSplitterTooltipContent: {
		id: 'page-container-v2.common.sidebar.side-bar-panel-splitter-tooltip-content',
		description:
			'Text content of the tooltip that appears when hovering over the side navigation resizing element, telling users that double clicking on the element will collapse the side nav',
		defaultMessage: 'Double click to collapse',
	},
	globalInviteButtonLabel: {
		id: 'page-container-v2.common.sidebar.global-invite-button-label',
		description: 'Text content of the button that triggers the modal dialog.',
		defaultMessage: 'Invite people',
	},
});
